// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import Api from './api/index.js';
import util from '../util/util'
import storage from 'good-storage'
import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx
Vue.config.productionTip = false
Vue.prototype.$api = Api;
Vue.prototype.util = util
Vue.prototype.$storage = storage
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js